import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "./context/authContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="229238640454-n2pp1ju01cm0ut0a8rqjs3s3b0f640pl.apps.googleusercontent.com">
    <AuthProvider>

        <App />
    </AuthProvider>
  </GoogleOAuthProvider>
);

reportWebVitals();
